export default __webpack_public_path__ + "static/media/co_pa_tx.5cf8543c.png";